import { SaveActionButtonsComponent } from '../../../components/save-action-buttons/save-action-buttons.component';
import { SaveActionButton } from '../../../components/save-action-buttons/save-action-button.model';
import { CommonModule } from '@angular/common';
import {
  NgbNav,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavContent,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbDropdownModule,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import { Signal } from '@angular/core';

import {
  ConfigStateService,
  LocalizationService,
  SubscriptionService,
  LocalizationModule,
} from '@abp/ng.core';
import { Confirmation, ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit, inject, Injector, ViewChild, computed, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from 'xng-breadcrumb';
import {
  AnnexesListComponent,
  CompanySiteStore,
  GoliathCoreEnumerationTypeStore,
} from '@digiwall/goliath-core';
import { GoliathContactsEnumerationTypeStore, SalesPersonStore } from '@digiwall/goliath-contacts';

import {
  DayBookService,
  SupplierPreparationDto,
  SupplierPreparationService,
  CreateUpdateSupplierPreparationDto,
  SupplierPreparationDefaultValueDto,
} from '@digiwall/goliath-documents/proxy';
import { SupplierService } from '@digiwall/goliath-contacts/proxy';
import { ClassificationTypeService, CurrencyService, DocRole } from '@digiwall/goliath-core/proxy';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { DocTemplateService } from '../../base-docs/detail/doc-template-selection/doc-template.service';
import { ReportViewerComponent } from '@odyssey/reporting';
import {
  ChatComponent,
  DeactivatableComponentService,
  DwInputAutoCompleteDirective,
  DwInputRequiredDirective,
  ErrorFormControlDirective,
} from '@digiwall/core';
import { SupplierPreparationLinesEditorComponent } from './supplier-preparation-lines/supplier-preparation-lines-editor.component';
import { BaseSupplierDocDetail } from '../../base-supplier-docs/base-supplier-doc-detail';
import {
  CounterComponent,
  DropdownMenu,
  DropdownMenuComponent,
  PanelComponent,
} from '@digiwall/ui-kit';
import { DwGridDetailNavigationComponent, DwTabsComponent } from '@digiwall/ag-grid';
import { DwNavLinkDirective } from '@digiwall/core';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { DwKeyboardShortcutDirective } from '@digiwall/core';
import { DwScrollSpyDirective } from '@digiwall/ag-grid';
import { DocConditionsComponent } from '../../base-docs/detail/doc-conditions/doc-conditions.component';
import { DocClassificationsComponent } from '../../base-docs/detail/doc-classifications/doc-classifications.component';
import { DocSupplierAddressesComponent } from '../../base-docs/detail/doc-supplier-addresses/doc-supplier-addresses.component';
import { DocSupplierOthersComponent } from '../../base-docs/detail/doc-supplier-others/doc-supplier-others.component';
import { AsyncPipe } from '@angular/common';
import { SidePanelComponent } from '@digiwall/ui-kit';
import { DialogBoxComponent } from '@digiwall/ui-kit';
import { DocSidePanelComponent } from '../../base-docs/detail/doc-ui-components/doc-side-panel/doc-side-panel.component';
import {
  DocNumberTagComponent,
  DocumentCoreCardComponent,
  DocumentSupplierCardComponent,
  SupplierDocumentDateCardComponent,
  SupplierDocumentStatusCardComponent,
} from '../../../components';
import { NgSelectModule } from '@ng-select/ng-select';
import { DocReportPermission } from '@digiwall/goliath-documents/config';
import { SupplierDeliveryMode } from '../../base-supplier-docs/supplier-delivery-mode.enum';
import { SupplierPreparationStatus } from '@digiwall/goliath-documents/proxy';
import { GenerateReceptionDialogComponent } from './generate-reception-dialog/generate-reception-dialog.component';
@Component({
  selector: 'document-supplier-preparation-detail',
  templateUrl: './supplier-preparation-detail.component.html',
  styleUrl: './supplier-preparation-detail.component.scss',
  providers: [DocTemplateService, SubscriptionService],
  imports: [
    CommonModule,
    PanelComponent,
    DwTabsComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    DwNavLinkDirective,
    NgbNavContent,
    NgbScrollSpy,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    DwKeyboardShortcutDirective,
    NgbScrollSpyFragment,
    DwScrollSpyDirective,
    SupplierPreparationLinesEditorComponent,
    DocConditionsComponent,
    DocClassificationsComponent,
    DocSupplierAddressesComponent,
    DocSupplierOthersComponent,
    AnnexesListComponent,
    NgbDropdownModule,
    DropdownMenuComponent,
    NgbNavOutlet,
    SaveActionButtonsComponent,
    SidePanelComponent,
    FormsModule,
    DialogBoxComponent,
    ReportViewerComponent,
    AsyncPipe,
    LocalizationModule,
    CounterComponent,
    ChatComponent,
    DwGridDetailNavigationComponent,
    DocSidePanelComponent,
    DocumentCoreCardComponent,
    DocumentSupplierCardComponent,
    SupplierDocumentDateCardComponent,
    SupplierDocumentStatusCardComponent,
    DwInputRequiredDirective,
    ErrorFormControlDirective,
    DwInputAutoCompleteDirective,
    NgSelectModule,
    DocNumberTagComponent,
  ],
})
export class SupplierPreparationDetailComponent
  extends BaseSupplierDocDetail<
    SupplierPreparationService,
    SupplierPreparationDto,
    CreateUpdateSupplierPreparationDto,
    SupplierPreparationDefaultValueDto
  >
  implements OnInit, OnDestroy
{
  @ViewChild('preparationLineGrid') preparationLineGrid: SupplierPreparationLinesEditorComponent;
  @ViewChild('report') reportViewer: ReportViewerComponent;

  docRole = DocRole.SupplierPreparation;
  protected override allowDraft = false;

  protected canGenerateReception = computed(
    () => this.entity?.supplierPreparationStatusId === SupplierPreparationStatus.Finished,
  );

  protected override saveActionBtns = computed((): SaveActionButton[] => [
    {
      label: this.localizationService.instant('::Save'),
      action: () => this.save(),
      disabled: () => !this.form.dirty,
    },
  ]);

  actions: Signal<DropdownMenu> = computed(() => {
    return {
      groups: [
        this.baseActionsThirdPartyDoc().concat(
          {
            label: '::GeneratePdf',
            icon: 'digi-out-pdf-file',
            action: () => this.generatePdf(this.reportViewer),
          },
          {
            label: '::Copy',
            icon: 'digi-out-copy',
            action: () => this.copy(),
          },
        ),
        [
          {
            label: 'Doc::GenerateDocPrintTemplate',
            icon: 'digi-out-edit-square',
            action: () => this.openDesigner(),
            requiredPolicy: DocReportPermission.Create,
          },
        ],
        [
          {
            label: 'Doc::SupplierPreparation:GenerateReception',
            icon: 'digi-out-delivery-box',
            action: () => this.openGenerateReception(),
            enabled: this.canGenerateReception,
          },
        ],
      ],
    };
  });

  enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
  contactEnumerationTypeStore = inject(GoliathContactsEnumerationTypeStore);
  coreEnumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);
  companySiteStore = inject(CompanySiteStore);
  salesPersonStore = inject(SalesPersonStore);
  protected supplierService = inject(SupplierService);
  protected currencyService = inject(CurrencyService);
  totalAmount: number = 0;
  totalAmountVatIncluded: number = 0;

  deliveryMode = SupplierDeliveryMode;

  showSearch: boolean;

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    preparationService: SupplierPreparationService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    classificationTypeService: ClassificationTypeService,
    preparationTemplateService: DocTemplateService,
    injector: Injector,
    thirdPartyService: SupplierService,
    config: ConfigStateService,
    confirmationService: ConfirmationService,
    deactivableComponentService: DeactivatableComponentService,
  ) {
    super(
      route,
      router,
      subscriptionService,
      preparationService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      preparationTemplateService,
      injector,
      thirdPartyService,
      config,
      confirmationService,
      deactivableComponentService,
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }
  override get formModel() {
    return Object.assign({}, super.formModel, {
      supplierPreparationStatusId: [null, Validators.required],
      receivingInstruction: [null],
      receivingFeedback: [null],
    });
  }

  private readonly EDITABLE_FIELDS = [
    'reference',
    'supplierPreparationStatusId',
    'receivingInstruction',
    'receivingFeedback',
  ] as const;

  private applyFormReadonlyState(): void {
    const isDraftOrReady =
      this.entity?.supplierPreparationStatusId === SupplierPreparationStatus.Draft ||
      this.entity?.supplierPreparationStatusId === SupplierPreparationStatus.Ready;

    this.form?.disable({ emitEvent: false });
    this.form?.get('classifications')?.enable({ emitEvent: false });

    if (isDraftOrReady) {
      this.EDITABLE_FIELDS.forEach(name => this.form?.get(name)?.enable({ emitEvent: false }));
    }
  }

  protected override enableForm(): void {
    this.applyFormReadonlyState();
  }

  override getEntityCallback(): void {
    super.getEntityCallback();

    this.preparationLineGrid?.lineGrid?.grid?.grid?.api?.redrawRows();
    this.applyFormReadonlyState();
  }

  private openGenerateReception(): void {
    this.formStateService.checkDirtyForm(this.form, () => {
      const canvasRef = this.offcanvasService.open(
        GenerateReceptionDialogComponent,
        this.injector,
        {
          position: 'end',
          panelClass: 'w-100 w-sm-75 w-3xl-50',
        },
      );
      (canvasRef.componentInstance as GenerateReceptionDialogComponent).preparationId =
        this.entity.id;
      canvasRef.closed.subscribeOnce((result: any) => {
        if (result?.type === 'success') {
          this.toastService.success(
            this.localizationService.instant(
              'Doc::SupplierPreparation:ReceptionGenerated',
              result.displayNumber,
            ),
          );
          this.refreshEntity();
        } else if (result?.type === 'noPreparedLines') {
          this.confirmationService
            .warn('Doc::SupplierPreparation:NoLinesConfirm', '')
            .subscribeOnce(x => {
              if (x !== Confirmation.Status.confirm) return;
              this.docService.close(this.entity.id).subscribeOnce(() => this.refreshEntity());
            });
        }
      });
    });
  }
}
